import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Button, Table } from "react-bootstrap";
import { currentUserRole, formatDateToDDMMYYYY } from "../../../Utility/constants";

const SchoolDetailsList = ({
  data,
  handleEdit,
  handleView,
  handleAffiliation,
  onAddNewSchool,
  handleDelete,
}) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>School Details</h2>
        {localStorage.getItem("Role") === "SUPERADMIN" ? (
          <Button variant="primary" onClick={onAddNewSchool}>
            Add School
          </Button>
        ) : (
          ""
        )}
      </div>

      <Table striped bordered hover>
        <thead className="thead-dark">
          <tr>
            <th style={{width: "2%"}}>#</th>           
            <th style={{width: "20%"}}>School Name</th>
            <th style={{width: "16%"}}>Principle Name</th>
            <th style={{width: "8%"}}>Phone No</th>
            <th style={{width: "17%"}}>Email</th>
            <th style={{width: "12%"}}>Registration Date</th>
            <th style={{textAlign:"center"}}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((school, index) => (
            <tr key={index + 1}>              
            <td>{index + 1}</td>
              <td>{school.schoolOrCollegeName}</td>
              <td>{school.principalName}</td>
              <td>{school.principalContactNo}</td>
              <td>{school.email}</td>
              <td>{formatDateToDDMMYYYY(school.createdOn)}</td>
              <td style={{display:"flex"}}>
                
                <Button
                  variant="warning"
                  onClick={() => handleEdit(school.schoolId)}
                  className="me-2"
                  title="General Info"
                >
                  GP
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => handleAffiliation(school.schoolId)}
                  className="me-2"
                  title="CAP - Contact & Affiliation Info"
                >
                  CAP
                </Button>
                {localStorage.getItem("Role") === "SUPERADMIN" && (
                  <Button
                    variant="danger"
                    onClick={() => handleDelete(school.schoolId)}
                     className="me-2"
                  >
                    Delete
                  </Button>
                )}
                <Button
                  variant="info"
                  onClick={() => handleView(school.schoolId)}
                  className="me-2"
                  title="view details"
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default SchoolDetailsList;
